export const ETAMONITORING_DESTINATIONS_FETCH_STARTED = 'ETAMONITORING_DESTINATION_FETCH_STARTED';
export const ETAMONITORING_DESTINATIONS_FETCH_COMPLETED =
  'ETAMONITORING_DESTINATION_FETCH_COMPLETED';
export const ETAMONITORING_DESTINATIONS_FETCH_FAILED = 'ETAMONITORING_DESTINATION_FETCH_FAILED';

export interface EtaDestination {
  isSelected: boolean;
  etaModelId: number;
  modelName: string;
}
